module.exports = __webpack_public_path__ + "img/74400.4fad23b9.jpg";